  document.addEventListener('click' , function(event){
    if(event.target.matches('.toggle-offers-list') || event.target.closest('.toggle-offers-list')){
      const target = event.target.matches('.toggle-offers-list') ? event.target : event.target.closest('.toggle-offers-list');
      const toggleElement = target.closest('.frees_gift_objects_list')?.querySelector('.full_details_of_offers');
      const openTitle = target.getAttribute('open-title');
      const closeTitle = target.getAttribute('close-title');
      target.querySelector('span').innerHTML = toggleElement.classList.contains('hidden') ? closeTitle : openTitle;
      target?.classList.toggle('oppen')
      toggleElement?.classList.toggle('hidden')
    }
    if(event.target.matches('.popup-gift-items-atc') || event.target.closest('.popup-gift-items-atc')){
      const target = event.target.matches('.popup-gift-items-atc') ? event.target : event.target.closest('.popup-gift-items-atc');
      const id = target.getAttribute('data-id');
      const popup = target.closest('.popup_free_gifts_wrapper');
      const loader = popup ? popup.querySelector('.gift_popup_loader') : null;
      // loader?.classList.remove('hidden');
       if(target && target.querySelector('span')){
      target.querySelector('span').textContent = 'Adding..'
      }
      addItemToCart(id , 1 , null , null , null , target )
    }
    if(event.target.matches('.popup-claim-gift-items-atc') || event.target.closest('.popup-claim-gift-items-atc')){
      const target = event.target.matches('.popup-claim-gift-items-atc') ? event.target : event.target.closest('.popup-claim-gift-items-atc');
      const id = target.getAttribute('data-id');
         const popup = target.closest('.popup_free_gifts_wrapper');
      const loader = popup ? popup.querySelector('.gift_popup_loader') : null;
      // loader?.classList.remove('hidden');
      const thisGrid  = target.closest('.wraper_gift-offer_gifts');
      const thisTitle = thisGrid.querySelector('.reminder_for_adding_gifts')
      const thisCard =  target.closest('.gift_card_product');
      const thisLimit =  thisCard.querySelector('[data-card-limit]').getAttribute('max') || 1;
      if(target && target.querySelector('span')){
      target.querySelector('span').textContent = 'Adding..'
      }
      if(target.closest('#claim-gifts-popup') && target.closest('#claim-gifts-popup').getAttribute('change-id') && parseInt(thisLimit) === parseInt(thisTitle.getAttribute('data-added'))){
        const changeId = target.closest('#claim-gifts-popup').getAttribute('change-id')
        changeProduct(changeId , id , 1 , true , thisLimit , thisTitle , target)
      }else{
      addItemToCart(id, 1, true , thisLimit , thisTitle , target);
      }

    }
    if(event.target.matches('.overlay_free_gifts') || event.target.matches('.close_btn_gift_popup') || event.target.closest('.close_btn_gift_popup')  || event.target.matches('.continue_without_gifts_btn') ){
      const targetPopup = event.target.closest('.popup_free_gifts_wrapper')
      targetPopup.classList.add('animating')
      setTimeout(() => {
      targetPopup.classList.add('hidden')
      }, 500);
      targetPopup.classList.remove('active')
      if(event.target.matches('.continue_without_gifts_btn')){
        document.querySelector('.cart__checkout-button')?.setAttribute('type' , "submit")
        window.location = '/checkout'
      }
    }
    if(event.target.matches('.add_more_gift-products') || event.target.closest('.add_more_gift-products')){
      const targetPopup = document.querySelector('#bundle-gifts-products-popup')
      targetPopup.classList.remove('hidden')
      targetPopup.classList.remove('animating')
      targetPopup.classList.add('active')
    }
    if(event.target.matches('.claim_free_gift_product') || event.target.closest('.claim_free_gift_product')){
      const target = event.target.matches('.claim_free_gift_product') ? event.target : event.target.closest('.claim_free_gift_product');
      const index = target.getAttribute('data-index')
      // fetchGiftByOfferIndex(index)
      const targetPopup = document.querySelector('#claim-gifts-popup')
      targetPopup.classList.remove('hidden','not-claimed')
      targetPopup.classList.remove('animating')
      targetPopup.classList.add('active') 
    }
    if(event.target.matches('.item_change_gift') || event.target.closest('.item_change_gift')){
      const targetPopup = document.querySelector('#claim-gifts-popup')
      targetPopup.classList.remove('hidden')
      targetPopup.classList.remove('animating')
      targetPopup.classList.add('active')
      const target = event.target.matches('.item_change_gift') ? event.target : event.target.closest('.item_change_gift');
      const index = target.getAttribute('data-index')
      // fetchGiftByOfferIndex(index)
      const changeId = target.getAttribute('data-id');
      targetPopup.setAttribute('change-id', changeId)
    }
    if(event.target.matches('.qty_box_gift_block') || event.target.closest('.qty_box_gift_block')){
      const qtyBlock =  event.target.matches('.qty_box_gift_block') ? event.target : event.target.closest('.qty_box_gift_block');
      const qtyBtns = qtyBlock.querySelectorAll('button');
      const qtyinput = qtyBlock.querySelector('input');
      const inputValue = parseInt(qtyinput.value)
      const inputmaxValue = parseInt(qtyinput.getAttribute('max'))
      if(event.target.hasAttribute('plus')){
          qtyinput.value =   inputValue < inputmaxValue ?  inputValue + 1 : inputValue ;
      }
      if(event.target.hasAttribute('minus')){
          qtyinput.value = inputValue > 1 ?  inputValue - 1 : inputValue ;
      }
      }
  })


function changeProduct(changeId, itemId, quantity, property , limit , title , target) {
  if(changeId) {
  const url = '/cart/change.js';
  const data = {
    id: changeId,
    quantity: 0,
  };

  fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
  .then(response => response.json())
  .then((response) => {
    if (response.status && response.status !== 200) {
      console.log('Failed to remove item:', response.message || 'No message provided');
    } else {
      console.log('Item removed successfully');
      if(title && limit){
        const addedItems = parseInt(title.getAttribute('data-added'))
        const addlimit = parseInt(limit)
        const newtitle = addedItems - 1 < 1  ? title.getAttribute('data-title') : (title.getAttribute('data-add-title')).replace('[added]' , addedItems - 1);
        title.querySelector('span').textContent = newtitle;
        title.setAttribute('data-added' , addedItems - 1)
      }
      addItemToCart(itemId, quantity, property , limit , title , target );
    }
  })
  .catch(error => {
    console.error('Error removing item from cart:', error);
  });
  } else
  {
      addItemToCart(itemId, quantity, property , limit , title , target);
  }
}

function addItemToCart(itemId, quantity, property , limit , title , target ) {
 const url = '/cart/add.js';
const data = {
  items: [{
    id: parseInt(itemId),
    quantity: quantity
  }]
};

if (property && property === true) {
  data.items[0].properties = data.items[0].properties || {};
  data.items[0].properties['_gift_product'] = true;
}

fetch(url, {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
  },
  body: JSON.stringify(data),
})
.then(response => response.json())
.then((response) => {
  if (response.status) {
    console.log('Failed to add item:', response.message || 'No message provided');
    document.querySelectorAll('.gift_popup_loader')?.forEach(l => l.classList.add('hidden'))
  } else {
    console.log('Item added to cart:', response);
    const location = window.location.href;
    let addedItems = 1
    let addlimit = 1
   
     if(title && limit){
         addedItems = parseInt(title.getAttribute('data-added'))
         addlimit = parseInt(limit)
        const newtitle = addedItems < 1 ? title.getAttribute('data-title') : (title.getAttribute('data-add-title')).replace('[added]' , addedItems + 1);
        title.querySelector('span').textContent = newtitle;
        title.setAttribute('data-added' , addedItems + 1)
       addedItems = parseInt(title.getAttribute('data-added'))
      }
      document.querySelectorAll('.gift_popup_loader')?.forEach(l => l.classList.add('hidden'))
    if(target && target.querySelector('span')){
      target.querySelector('span').textContent = 'Added to cart'
      target.classList.add('item_added')
      target.setAttribute('disabled' , true )
    }
     console.log('addedItems' , addedItems)
    console.log('addlimit' , addlimit)
    if(addedItems >= addlimit){
    if(location.includes('/cart')){
      window.location.reload();
      // alert('added')
    } else {
      window.location.href = "/cart";
    }
    }
  }
})
.catch(error => {
  console.error('Error adding item to cart:', error);
});

}
function fetchGiftByOfferIndex(index) {
  fetch(`/cart?offer-index=${index}&section_id=gift-popup`)
    .then(cartResponse => cartResponse.text())
    .then(cartHtml => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(cartHtml, 'text/html');
      const newContent = doc.querySelector('#filter-gifts');
      const newContentHeader = doc.querySelector('#filter-gift-header');
      const myDiv =  document.querySelector('#claim_gift_popup');
      const myHeader = document.querySelector('#claim-gift-header');
      if (myHeader && newContentHeader) {
        myHeader.innerHTML = newContentHeader.innerHTML;
      }
        console.log('Target Updated' , myHeader , newContentHeader);
      if (myDiv && newContent) {
        myDiv.innerHTML = newContent.innerHTML;
      } else {
        console.log('Target div or content not found');
      }
    })
    .catch(cartError => {
      console.error('Error fetching the cart HTML:', cartError);
    });
}
function updatePopupContent(updateAll) {
  fetch('/cart?view=gift-popup')
    .then(cartResponse => cartResponse.text())
    .then(cartHtml => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(cartHtml, 'text/html');
      const newContent = updateAll === true ? doc.querySelector('#bundle-gift-container-popup') : doc.querySelector('#bundle-gift-container-popup-header');
      const loader = doc.querySelector('.gift_popup_loader');
      loader.classList.add('hidden');
      const myDiv =  updateAll === true ? document.querySelector('#bundle-gift-container-popup') : document.querySelector('#bundle-gift-container-popup-header');
      if (myDiv && newContent) {
        myDiv.innerHTML = newContent.innerHTML;
        console.log('Target Updated');
      } else {
        console.log('Target div or content not found');
      }
    })
    .catch(cartError => {
      console.error('Error fetching the cart HTML:', cartError);
    });
}








// ============================Slider =======================
function initializeDragScroll(gridOfferProducts) {
  let isDragging = false;
  let startX;
  let scrollLeft;

  // Create and add navigation buttons
  const navigationWrapper = document.createElement('div');
  navigationWrapper.className = 'slider-navigation';
  
  const prevButton = document.createElement('button');
  prevButton.className = 'nav-button prev';
  prevButton.innerHTML = `
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `;

  const nextButton = document.createElement('button');
  nextButton.className = 'nav-button next';
  nextButton.innerHTML = `
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `;

  // Add navigation buttons to wrapper
  navigationWrapper.appendChild(prevButton);
  navigationWrapper.appendChild(nextButton);
  
  // Insert navigation wrapper after the slider
  gridOfferProducts.parentNode.insertBefore(navigationWrapper, gridOfferProducts.nextSibling);

  // Button click handlers
  prevButton.addEventListener('click', () => {
    const scrollAmount = gridOfferProducts.offsetWidth * 0.8; // Scroll 80% of container width
    gridOfferProducts.scrollBy({
      left: -scrollAmount,
      behavior: 'smooth'
    });
  });

  nextButton.addEventListener('click', () => {
    const scrollAmount = gridOfferProducts.offsetWidth * 0.8;
    gridOfferProducts.scrollBy({
      left: scrollAmount,
      behavior: 'smooth'
    });
  });

  // Check scroll position to show/hide buttons
  function updateButtonVisibility() {
  const isAtStart = gridOfferProducts.scrollLeft <= 0;
  const isAtEnd = gridOfferProducts.scrollLeft + gridOfferProducts.clientWidth >= gridOfferProducts.scrollWidth;

  prevButton.toggleAttribute('disabled', isAtStart);
  nextButton.toggleAttribute('disabled', isAtEnd);
}

  // Add scroll event listener to update button visibility
  gridOfferProducts.addEventListener('scroll', updateButtonVisibility);
  // Initial button visibility check
  updateButtonVisibility();

  // Existing drag functionality
  gridOfferProducts?.addEventListener('mousedown', (e) => {
    isDragging = true;
    startX = e.pageX - gridOfferProducts.offsetLeft;
    scrollLeft = gridOfferProducts.scrollLeft;
  });

  gridOfferProducts?.addEventListener('mouseleave', () => {
    isDragging = false;
  });

  gridOfferProducts?.addEventListener('mouseup', () => {
    isDragging = false;
  });

  gridOfferProducts?.addEventListener('mousemove', (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - gridOfferProducts.offsetLeft;
    const walk = (x - startX) * 3;
    gridOfferProducts.scrollLeft = scrollLeft - walk;
  });
}


// Initialize for all existing sliders
function initializeAllSliders() {
  const allGridOfferProducts = document.querySelectorAll('.gifts-slider-grid');
  allGridOfferProducts.forEach(slider => {
    initializeDragScroll(slider);
  });
}

// Optional: Observer to automatically initialize new sliders
const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType === 1 && node.matches('.gifts-slider-grid')) {
        initializeDragScroll(node);
      }
      
      if (node.nodeType === 1) {
        const newSliders = node.querySelectorAll('.gifts-slider-grid');
        newSliders.forEach(slider => {
          initializeDragScroll(slider);
        });
      }
    });
  });
});

// Start observing
observer.observe(document.body, {
  childList: true,
  subtree: true
});

// Initial call
initializeAllSliders();




